import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DiscountLabel from './DiscountLabel'
import WishlistHeart from 'Wishlist/WishlistHeart'
import CardImage from 'Catalog/Product/ProductCard/CardImage'
// import OfferCountdown from './OfferCountdown'
import CardTitle from 'Catalog/Product/ProductCard/CardTitle'
import CardPartner from 'Catalog/Product/ProductCard/CardPartner'

import Availability from 'Catalog/Availability'
import CardInternal from 'Catalog/Product/ProductCard/CardInternal'
import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'

import MediaQuery from 'react-responsive'
import Tagging from './Tagging'

import { withRouter } from 'react-router'

class ProductCard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sendGTM: false
    }
  }
  TaggingClick () {
    this.setState({ sendGTM: true })
    setTimeout(() => {
      this.props.history.push('/products/' + this.props.sku)
    }, 300)
  }
  render () {
    const { sku,
      imageUrl,
      name,
      originalId,
      vendorId,
      vendorName,
      className,
      isResponsiveEnabled,
      discount } = this.props

    return (
      <IsResponsiveEnabledContext.Provider value={isResponsiveEnabled}>
        <div className={`item card cursor ${className}`}>
          { this.state.sendGTM && <Tagging type='click' {...this.props} /> }
          <a href='javascript:void(0)' onClick={() => this.TaggingClick()} title={`Acesse o produto`}>
            <div className='bordered radius border-color-ui-2 bg-white'>
              <MediaQuery minDeviceWidth={769}>
                <WishlistHeart className='card-wishlist pos-absolute' sku={sku} />
              </MediaQuery>

              <div className='row mx-0 px-0'>
                <div className='col-12 discount-whishlist'>
                  <DiscountLabel discount={discount} />
                </div>

                <CardImage
                  imageUrl={imageUrl}
                  altText={name}
                  linkTo={`/products/${sku}`}
                />
                {/* <OfferCountdown /> */}
                <CardInternal>
                  <CardTitle title={name} vendorName={vendorName} />
                  <CardPartner vendorId={vendorId} />
                  {vendorId && originalId && sku && (
                    <Availability
                      sku={sku}
                      originalId={originalId}
                      vendorId={vendorId}
                    />
                  )}

                </CardInternal>

              </div>
            </div>
          </a>
        </div>
      </IsResponsiveEnabledContext.Provider>
    )
  }
}

ProductCard.propTypes = {
  sku: PropTypes.string.isRequired,
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  originalId: PropTypes.string,
  vendorId: PropTypes.string,
  vendorName: PropTypes.string,
  className: PropTypes.string,
  isResponsiveEnabled: PropTypes.bool,
  discount: PropTypes.number,
  history: PropTypes.object
}

export default withRouter(ProductCard)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/ProductCard.js